<template>
    <div class="body">
        <div class="top">
            <div class="t_left">
                <div class="tl_left">请选择班级</div>
                <!-- <div class="tl_right" @click="$router.push({ path: '/classList'})">班级管理</div> -->
            </div>
            <img src="../../assets/img/i10.png" />
        </div>
        <div class="list">
            <el-empty description="暂无数据" v-if="list.length == 0"></el-empty>
            <div class="item" v-for="(item, index) in list" :key="index"
                @click="$router.push({ path: '/trClassroomDetail', query: { id: item.id } })">
                <div class="i_left">
                    <img :src="webImg + item.logo" />
                    <div v-if="item.bzrFlag == 1">班主任</div>
                </div>
                <div class="i_right">
                    <div class="ir_left">
                        <div>{{ item.name }}</div>
                        <div>老师{{ item.teacherNum }}人 | 学生{{ item.studentNum }}人</div>
                        <!-- <div>七米号：93004940</div> -->
                    </div>
                    <div class="ir_right"
                        @click.stop="$router.push({ path: '/trClassroomDetail', query: { id: item.id, flag: 1 } })">新建课堂
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>检测到当前没有班级，是否前往创建或加入班级？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    myClassList,
} from '@/apis/index'
export default {
    data() {
        return {
            list: [],
            dialogVisible:false
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        confirm(){
            this.dialogVisible = false
            this.$router.push({ path: '/classList' , query: { flag: 1 }})
        },
        getList() {
            myClassList().then(res => {
                console.log(res, 'res');
                this.list = res.data
                
                if (this.list.length == 0) {
                    this.dialogVisible = true
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep{
    .el-dialog{
        z-index: 99 ;
    }
}
.body {
    width: 860px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .top {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0 45px 0;
        margin-top: 90px;

        .t_left {
            display: flex;
            align-items: center;

            .tl_left {
                font-weight: bold;
                font-size: 24px;
                color: #000000;
            }

            .tl_right {
                font-size: 16px;
                color: #2B63F3;
                margin-left: 15px;
                text-decoration: underline;
                cursor: pointer;
            }
        }


        img {
            width: 86px;
            height: 108px;
        }
    }

    .list::-webkit-scrollbar {
        display: none;
    }

    .list {
        flex: 1;
        width: 100%;
        height: 0;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        // align-content: flex-start;
        // flex-wrap: wrap;
        overflow-y: scroll;
        margin-bottom: 20px;

        .item {
            width: 100%;
            height: 170px;
            background: #FFFFFF;
            box-shadow: 0px 2px 24px 0px rgba(190, 198, 204, 0.25);
            border-radius: 20px 20px 20px 20px;
            border: 1px solid #F8F8F8;
            box-sizing: border-box;
            padding: 0 45px;
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            cursor: pointer;

            .i_left {
                position: relative;
                width: 100px;
                height: 100px;
                display: flex;
                flex-direction: column;
                align-items: center;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background-color: #c2c2c2;
                }

                div {
                    width: 54px;
                    height: 22px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #2992FF;
                    font-weight: 500;
                    font-size: 14px;
                    color: #2992FF;
                    text-align: center;
                    line-height: 22px;
                    position: absolute;
                    bottom: -10px;
                }
            }

            .i_right {
                flex: 1;
                margin-left: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .ir_left {

                    div:nth-child(1) {
                        font-weight: bold;
                        font-size: 20px;
                        color: #000000;
                    }

                    div:nth-child(2) {
                        font-weight: 500;
                        font-size: 16px;
                        color: #666666;
                        margin: 14px 0;
                    }

                    div:nth-child(3) {
                        font-weight: 500;
                        font-size: 16px;
                        color: #666666;
                    }
                }

                .ir_right {
                    width: 104px;
                    height: 36px;
                    background: #399AFF;
                    border-radius: 8px 8px 8px 8px;
                    font-weight: 800;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 36px;
                    cursor: pointer;
                }
            }

        }
    }
}
</style>